module.exports = __webpack_public_path__ + "static/img/logo_zhike.f713a8db.png";